import { render, staticRenderFns } from "./BaseSingleDate.vue?vue&type=template&id=55ea9b45&scoped=true&"
import script from "./BaseSingleDate.vue?vue&type=script&lang=js&"
export * from "./BaseSingleDate.vue?vue&type=script&lang=js&"
import style0 from "./BaseSingleDate.vue?vue&type=style&index=0&id=55ea9b45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ea9b45",
  null
  
)

export default component.exports